import crypto from 'crypto';

import Constant from 'Constantjs';

/**
* 加密字符串
*/
export function toCode(str) {
  // 定义密钥，26个字母和10数字
  const key = "GH8CA7F10IJKPBLMNO239EQR6YST5UVW4XDZ";
  const l = 36;  // 获取密钥的长度
  const arr = key.split('');  // 把密钥字符串转换为字符数组
  let s = '';
  for (let i = 0; i < str.length; i += 1) {  // 遍历字符串
    const b = str.charCodeAt(i);  // 逐个提取每个字符，并获取Unicode编码值
    const b1 = b % l;  // 求Unicode编码值得余数
    const b2 = (b - b1) / l; // 求最大倍数
    s += arr[b2] + arr[b1];  // 拼接
  }
  return s;  // 返回这些映射的字符
}

/**
 * 解密字符串
 */
export function deCode(str) {
  const key = "GH8CA7F10IJKPBLMNO239EQR6YST5UVW4XDZ";
  const l = 36; 
  const s = new Array(Math.floor(str.length / 2));  // 计算加密字符串包含的字符数，并定义数组
  const codeS = [];
  for (let i = 0; i < s.length; i += 1) { 
      const b2 = key.indexOf(str.charAt(i * 2));
      const b1 = key.indexOf(str.charAt(i * 2 + 1));
      const code = l * b2 + b1;
      codeS[i] = String.fromCharCode(code);
  }
  return codeS.join('');  // 返回被解密的字符串
}

/**
 * 使用公钥 rsa 加密
 * payload = {
 *  m: ''  // 手机号
 * }
*/
export function publicKeyDer(payload) {
  const SKSXENV = process.env.REACT_APP_SKSXENV;
  const publicKeyData = deCode(Constant.publicKey[SKSXENV]); // 公钥
  const msg = JSON.stringify(payload);
  const publicDer = crypto.publicEncrypt({
    key: publicKeyData, 
    padding: crypto.constants.RSA_PKCS1_PADDING
  }, Buffer.from(msg));
  return publicDer.toString('base64');
}